module.exports = __webpack_public_path__ + "static/img/Q500.a244894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Q500.png
// module id = Yuk3
// module chunks = 2